module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__page-list-event-layout"
  }, [_c('catalog-list', {
    attrs: {
      "sort": _vm.sort,
      "items": _vm.items,
      "doubler": _vm.doubler,
      "title": _vm.title
    }
  }, [(_vm.$slots.default) ? _c('template', {
    slot: "prefix"
  }, [_vm._t("default")], 2) : _vm._e(), _c('catalog-sort', {
    attrs: {
      "slot": "before",
      "items": _vm.sortList
    },
    slot: "before"
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-176b3268","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/event-list/EventList.vue
// module id = d57e29d76af096feec33
// module chunks = 38